(function () {
  'use strict';

  var SCENTS = window.MIILK_SCENTS || [];

  var byKey = {};
  SCENTS.forEach(function (s, i) { s.index = i; byKey[s.key] = s; });

  var modal = document.getElementById('seModal');
  if (!modal) return;
  var dialog = modal.querySelector('.se-dialog');
  var video = modal.querySelector('.se-video');
  var bottle = modal.querySelector('.se-media-bottle');
  var media = modal.querySelector('.se-media');
  var mediaBg = modal.querySelector('.se-media-bg');
  var bigplay = modal.querySelector('.se-bigplay');
  var mediaTag = modal.querySelector('.se-media-tag');

  var current = 0;
  var lastFocus = null;

  /* ══════════════════════════════════════════
     CART DRAWER HELPERS (same pattern as "The Four" section,
     so the real theme cart-drawer actually updates)
  ══════════════════════════════════════════ */
  function getDrawerSectionId() {
    var w = document.querySelector('[data-section-type="cart-drawer"]');
    if (w && w.dataset.sectionId) return w.dataset.sectionId;
    var d = document.querySelector('cart-drawer#cart-drawer') || document.querySelector('cart-drawer');
    if (d) {
      var p = d.closest('[data-section-id]');
      if (p) return p.dataset.sectionId;
    }
    return null;
  }

  function updateCartCount(n) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < 0) n = 0;
    document.querySelectorAll('cart-count').forEach(function (el) {
      el.setAttribute('data-cart-count', n);
      var lim = parseInt(el.dataset.limit, 10);
      el.textContent = !isNaN(lim) && lim > 0 && n > lim ? lim + '+' : String(n);
    });
    [
      '[data-cart-count]:not(cart-count)',
      '.cart-count',
      '.cart__count',
      '.cart-item-count',
      '.header__cart-count',
      '.cart-link__bubble-num',
      '[data-item-count]',
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = String(n);
        if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', n);
        if (el.hasAttribute('data-item-count')) el.setAttribute('data-item-count', n);
      });
    });
  }

  function replaceDrawer(html) {
    if (!html) return;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nd = doc.querySelector('cart-drawer');
      var od = document.querySelector('cart-drawer#cart-drawer') || document.querySelector('cart-drawer');
      if (nd && od) {
        var open = [];
        ['is-active', 'active', 'open', 'is-open', 'drawer--open'].forEach(function (c) {
          if (od.classList.contains(c)) open.push(c);
        });
        var imp = document.importNode(nd, true);
        od.parentNode.replaceChild(imp, od);
        open.forEach(function (c) {
          imp.classList.add(c);
        });
        imp.querySelectorAll('script').forEach(function (os) {
          var ns = document.createElement('script');
          Array.prototype.forEach.call(os.attributes, function (a) {
            ns.setAttribute(a.name, a.value);
          });
          ns.textContent = os.textContent;
          os.parentNode.replaceChild(ns, os);
        });
      }
    } catch (e) {
      console.error('[Meet your milks] Drawer swap:', e);
    }
  }

  function openCartDrawer() {
    var d = document.querySelector('cart-drawer#cart-drawer') || document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') {
      try {
        d.open();
        return;
      } catch (e) {}
    }
    var t =
      document.querySelector('[data-action="open-drawer"][data-drawer-id="cart-drawer"]') ||
      document.querySelector('[aria-controls="cart-drawer"]:not([data-cart-drawer-close])') ||
      document.querySelector('.navlink--cart') ||
      document.querySelector('[data-cart-toggle]');
    if (t) {
      try {
        t.click();
        return;
      } catch (e) {}
    }
    ['theme:drawer:open', 'drawer:open', 'cart-drawer:open'].forEach(function (e) {
      try {
        document.dispatchEvent(new CustomEvent(e, { bubbles: true, detail: { drawer: 'cart-drawer' } }));
      } catch (_) {}
    });
    if (d) {
      d.classList.add('is-active', 'active', 'open', 'is-open', 'drawer--open');
      d.removeAttribute('hidden');
    }
  }

  function addToCartRequest(variantId) {
    var dsid = getDrawerSectionId();
    var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
    if (dsid) {
      body.sections = dsid;
      body.sections_url = window.location.pathname || '/';
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (!r.ok)
          return r.json().then(function (e) {
            throw e;
          });
        return r.json();
      })
      .then(function (data) {
        if (dsid && data.sections && data.sections[dsid]) replaceDrawer(data.sections[dsid]);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var cnt = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
            updateCartCount(cnt);
            ['theme:cart:reload', 'theme:cart:change', 'cart:refresh', 'cart:change', 'cart:updated'].forEach(
              function (e) {
                try {
                  document.dispatchEvent(new CustomEvent(e, { bubbles: true, detail: cart }));
                } catch (_) {}
              }
            );
            setTimeout(function () { updateCartCount(cnt); }, 150);
            setTimeout(function () { updateCartCount(cnt); }, 500);
            setTimeout(openCartDrawer, 120);
            return data;
          });
      });
  }

  /* ---------- video ---------- */
  function loadVideo(src) {
    if (!src) return;
    video.classList.remove('ready');
    video.muted = true;
    video.pause();
    video.removeAttribute('src');
    video.load();
    video.src = src;
    video.load();
    video.addEventListener('loadeddata', function () { video.classList.add('ready'); }, { once: true });
    var p = video.play();
    if (p && p.catch) {
      p.catch(function (err) {
        console.warn('[Meet your milks] Video autoplay was blocked:', err);
        bigplay.classList.remove('hide');
      });
    }
  }

  function playFilm() {
    var s = SCENTS[current];
    bigplay.classList.add('hide');
    loadVideo(s.video);
  }

  function stopFilm() {
    try { video.pause(); } catch (e) {}
    video.classList.remove('ready');
    video.removeAttribute('src');
  }

  /* ---------- render ---------- */
  function pyramidHTML(p) {
    return p.map(function (st) {
      return '' +
        '<div class="se-stage">' +
          '<div class="se-stage-rail"><span class="se-dot"></span></div>' +
          '<div class="se-stage-main">' +
            '<div class="se-stage-top"><span class="se-stage-label">' + st.stage + '</span>' +
            '<span class="se-stage-time">' + st.time + '</span></div>' +
            '<div class="se-stage-notes">' + st.notes + '</div>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  function render(i) {
    current = (i + SCENTS.length) % SCENTS.length;
    var s = SCENTS[current];

    dialog.className = 'se-dialog t-' + s.key;
    stopFilm();
    bottle.src = s.still || s.bottle;
    bottle.alt = s.name + ' Miilk';
    media.classList.toggle('has-still', !!s.still);
    mediaBg.style.backgroundImage = s.still ? 'url("' + s.still + '")' : 'none';
    mediaTag.textContent = s.name;

    modal.querySelector('.se-head-no').textContent = s.no;
    modal.querySelector('.se-head-full').textContent = s.full;

    var nameEl = modal.querySelector('.se-panel .se-name');
    nameEl.textContent = s.name + ' Miilk';
    nameEl.style.color = s.accentColor || '';

    modal.querySelector('.se-story').textContent = s.story;
    modal.querySelector('.se-pyr').innerHTML = pyramidHTML(s.pyramid);
    modal.querySelector('.se-wear').textContent = s.wear;
    modal.querySelector('.se-who').textContent = s.who;
    modal.querySelector('.se-price').textContent = s.price;

  var fp = modal.querySelector('.se-fullpage');

  if (fp) fp.setAttribute('href', s.productUrl || ('product.html#' + s.key));
  fp.addEventListener('click', function() {
  window.location.href = this.href;
});


    var addBtn = modal.querySelector('.se-add');
    addBtn.dataset.variantId = s.variantId || '';
    addBtn.dataset.productId = s.productId || '';
    var lbl = addBtn.querySelector('.mh-btn-label');
    if (s.variantId) {
      addBtn.disabled = false;
      if (lbl) lbl.textContent = 'Add to bag'; else addBtn.textContent = 'Add to bag';
      addBtn.style.background = s.accentColor || '';
    } else {
      addBtn.disabled = true;
      if (lbl) lbl.textContent = 'Unavailable'; else addBtn.textContent = 'Unavailable';
    }

    var dots = modal.querySelector('.se-dots');
    dots.innerHTML = SCENTS.map(function (sc, idx) {
      return '<button class="se-dot-nav' + (idx === current ? ' active' : '') +
        '" type="button" data-go="' + idx + '" aria-label="Go to ' + sc.name + '"></button>';
    }).join('');

    modal.querySelector('.se-panel-scroll').scrollTop = 0;

    if (s.video) {
      bigplay.classList.add('hide');
      loadVideo(s.video);
    } else {
      bigplay.classList.add('hide');
    }
  }

  /* ---------- open / close ---------- */
  function open(key) {
    lastFocus = document.activeElement;
    render(byKey[key] ? byKey[key].index : 0);
    modal.classList.add('open');
    document.body.classList.add('se-lock');
    void modal.offsetWidth;
    modal.classList.add('in');
    modal.setAttribute('aria-hidden', 'false');
    modal.querySelector('.se-close').focus();
  }

  function close() {
    modal.classList.remove('in');
    stopFilm();
    document.body.classList.remove('se-lock');
    modal.setAttribute('aria-hidden', 'true');
    setTimeout(function () {
      modal.classList.remove('open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }, 280);
  }

  function go(dir) { render(current + dir); }

  /* ---------- wire ---------- */
  document.querySelectorAll('.se-tile').forEach(function (tile) {
    tile.addEventListener('click', function () { open(tile.getAttribute('data-scent')); });
  });

  bigplay.addEventListener('click', playFilm);

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-se-close]')) { close(); return; }
    if (e.target.closest('[data-se-prev]')) { go(-1); return; }
    if (e.target.closest('[data-se-next]')) { go(1); return; }
    var dot = e.target.closest('[data-go]');
    if (dot) { render(parseInt(dot.getAttribute('data-go'), 10)); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (!modal.classList.contains('open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'ArrowRight') go(1);
  });

  /* ---------- REAL add-to-cart (theme drawer aware) ---------- */
  var addBtn = modal.querySelector('.se-add');

  addBtn.addEventListener('click', function () {
    if (addBtn.disabled) return;
    var variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    var lbl = addBtn.querySelector('.mh-btn-label');
    var original = lbl ? lbl.textContent : addBtn.textContent;

    addBtn.classList.add('is-loading');
    addBtn.disabled = true;
    if (lbl) lbl.textContent = 'Adding...'; else addBtn.textContent = 'Adding...';

    addToCartRequest(variantId)
      .then(function () {
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-added');
        if (lbl) lbl.textContent = 'Added ✓'; else addBtn.textContent = 'Added ✓';
        close();
        setTimeout(function () {
          addBtn.classList.remove('is-added');
          if (lbl) lbl.textContent = original; else addBtn.textContent = original;
          addBtn.disabled = false;
        }, 2200);
      })
      .catch(function (err) {
        addBtn.classList.remove('is-loading');
        addBtn.disabled = false;
        if (lbl) lbl.textContent = original; else addBtn.textContent = original;
        console.error('[Meet your milks] Add to cart error:', err);
      });
  });
})();